<template>
  <div>
    <custom-modal :title="'Ponawianie zamówienia'" :id="`${modalName}`">
      <template #content>
        <div class="modal-body" v-if="order">
          <div class="calendar">
            <v-calendar
              :attributes="attributes"
              @dayclick="onDayClick"
              :columns="2"
              :min-date="minOrderDate"
              :max-date="new Date(new Date().getTime() + 31556952000)"
              class="p-3"
            ></v-calendar>
            <p style="margin-top: 1rem" v-if="days && days.length">
              <b>Wybrane dni:</b>
            </p>
            <div class="days">
              <span v-for="day in days" :key="day.id">
                <span style="margin: 10px">{{ day.id }}</span>
              </span>
            </div>
          </div>
        </div>

        <order-for-senior-customer-data
          v-if="order && days && days.length"
          :days="days"
          :selectedService="
            order && order.userService
              ? order.userService.id
              : order.user_service_id
          "
          :userProfile="userById"
          :userPromotionalCodes="userPromotionalCodes"
          :previousOrder="order"
          @orderAdded="handleOrderAdded"
        />
      </template>
    </custom-modal>
    <button
      style="visibility: hidden"
      :id="`${modalName}-open`"
      type="button"
      data-toggle="modal"
      :data-target="`#${modalName}`"
    />
  </div>
</template>

<script>
import VCalendar from "v-calendar/lib/components/calendar.umd";
import moment from "moment";
import CustomModal from "./CustomModal.vue";
import OrderForSeniorCustomerData from "./OrderForSeniorCustomerData.vue";
export default {
  props: {
    userPromotionalCodes: { required: true },
    modalName: {
      type: String,
      required: true,
    },
    order: {
      type: Object,
      required: false,
    },
  },
  emits: ["orderRepeated"],
  components: { CustomModal, VCalendar, OrderForSeniorCustomerData },
  name: "RepeatOrderModal",
  data() {
    return {
      loading: false,
      days: [],
    };
  },
  async created() {},

  methods: {
    async handleOrderAdded() {
      await this.$emit("orderRepeated");
      this.days = [];
      this.closeModal();
    },
    closeModal() {
      document.getElementById(`${this.modalName}-close`).click();
    },

    onDayClick(day) {
      if (
        moment(day.id).isAfter(moment(this.minOrderDate).add(-1, "day"), "day")
      ) {
        const idx = this.days.findIndex((d) => d.id === day.id);
        if (idx >= 0) {
          this.days.splice(idx, 1);
        } else {
          this.days.push({
            id: day.id,
            date: day.date,
          });
        }
      }
    },
  },
  computed: {
    dates() {
      return this.days.map((day) => day.date);
    },
    attributes() {
      return this.dates.map((date) => ({
        highlight: {
          color: moment(date).startOf("day").isBefore(moment().startOf("day"))
            ? "red"
            : "blue",
          fillMode: "solid",
        },
        dates: date,
      }));
    },
    minOrderDate() {
      return moment().subtract(2, "weeks").toDate();
    },
    userById() {
      return this.$store.getters.getUserById;
    },
  },
};
</script>

<style scoped>
.modal-body {
  font-size: 14px;
  padding: 10px;
}
div {
  padding: 0;
}
.calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  margin-bottom: 3rem;
}
</style>